import { getAppFetch } from 'modules/shopify';

let baseUrl = 'https://bucksapop.web.app';
if (window.location.host.indexOf('localhost') !== -1) {
  baseUrl = 'http://localhost:5001/bucksapop/us-central1/api';
}

async function authFetch(url, options = {}) {
  const fetch = getAppFetch();
  const response = await fetch(url, options);
  if (!response.ok) {
    const error = new Error('HTTP ' + response.status);
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export const getUser = () => authFetch(baseUrl + '/api/user');

export const getCodes = (status, page, search) =>
  authFetch(baseUrl + '/api/user/codes?status=' + status + '&page=' + page + '&search=' + search);

export const getUsers = (page, search) =>
  authFetch(baseUrl + '/api/user/users?page=' + page + '&search=' + search);

export const generateCodes = (data) =>
  authFetch(baseUrl + '/api/user/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const getRequests = () => authFetch(baseUrl + '/api/user/requests');

export const adjustUserToken = (customerId, action, tokens) =>
  authFetch(baseUrl + '/api/user/adjust-token?customerId=' + customerId + '&action=' + action + '&tokens=' + tokens);

export const downloadRequestCsv = async (requestId) => {
  const fetch = getAppFetch();
  const response = await fetch(baseUrl + '/api/user/requests/' + requestId + '/csv');
  if (!response.ok) throw new Error('HTTP ' + response.status);
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'codes_' + requestId + '.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
